module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('van-notice-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "text": "请填写真实可收件地址，以便后期邮寄培训班相关物料。"
    }
  }), _vm._v(" "), _c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "赛季",
      "input-align": "right",
      "readonly": ""
    },
    model: {
      value: (_vm.formData.saiji_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "saiji_name", $$v)
      },
      expression: "formData.saiji_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "赛事类型",
      "rules": [{
        required: true,
        message: '请选择赛事类型'
      }],
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "vertical"
          },
          on: {
            "change": _vm.typeChange
          },
          model: {
            value: (_vm.formData.type_name),
            callback: function($$v) {
              _vm.$set(_vm.formData, "type_name", $$v)
            },
            expression: "formData.type_name"
          }
        }, [_c('van-radio', {
          key: 0,
          attrs: {
            "checked-color": "#ffb01b",
            "name": "全国啦啦操联赛"
          }
        }, [_vm._v("全国啦啦操联赛")]), _vm._v(" "), _c('van-radio', {
          key: 1,
          attrs: {
            "checked-color": "#ffb01b",
            "name": "全国少儿啦啦操精英赛"
          }
        }, [_vm._v("全国少儿啦啦操精英赛")]), _vm._v(" "), _c('van-radio', {
          key: 2,
          attrs: {
            "checked-color": "#ffb01b",
            "name": "全国啦啦操俱乐部联赛"
          }
        }, [_vm._v("全国啦啦操俱乐部联赛")])], 1)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "赛事时间",
      "input-align": "right",
      "readonly": ""
    },
    on: {
      "click": function($event) {
        _vm.dateShow = true
      }
    },
    model: {
      value: (_vm.formData.date_time),
      callback: function($$v) {
        _vm.$set(_vm.formData, "date_time", $$v)
      },
      expression: "formData.date_time"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("至少2晚3天，允许3晚4天。")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? (_vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county) : '',
      "input-align": "right",
      "label": "赛事地点",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "赛事站名",
      "value": _vm.saiName,
      "input-align": "right",
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showeArea),
      callback: function($$v) {
        _vm.showeArea = $$v
      },
      expression: "showeArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.earea
    },
    on: {
      "confirm": _vm.oneAreaConfirm,
      "cancel": function($event) {
        _vm.showeArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入人数'
      }],
      "error-message-align": "right",
      "label": "预估参赛人数",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入人数"
    },
    model: {
      value: (_vm.formData.member),
      callback: function($$v) {
        _vm.$set(_vm.formData, "member", $$v)
      },
      expression: "formData.member"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.formData.admin_list), function(member, index) {
    return _c('div', {
      key: index
    }, [_c('van-divider', [_vm._v("赛事负责人" + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
      attrs: {
        "clearable": "",
        "input-align": "right",
        "error-message-align": "right",
        "label": "姓名",
        "placeholder": "请输入姓名",
        "rules": [{
          required: true,
          message: '请输入姓名'
        }]
      },
      model: {
        value: (member.name),
        callback: function($$v) {
          _vm.$set(member, "name", $$v)
        },
        expression: "member.name"
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "clearable": "",
        "rules": [{
          validator: _vm.validator.phone,
          message: '请输入正确的手机号'
        }],
        "error-message-align": "right",
        "input-align": "right",
        "label": "手机",
        "placeholder": "请输入手机号"
      },
      model: {
        value: (member.phone),
        callback: function($$v) {
          _vm.$set(member, "phone", $$v)
        },
        expression: "member.phone"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.2rem"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('van-button', {
      staticStyle: {
        "width": "3rem"
      },
      attrs: {
        "native-type": "button",
        "size": "normal",
        "round": "",
        "icon": "close"
      },
      on: {
        "click": function($event) {
          return _vm.adminRemove(member, index)
        }
      }
    }, [_vm._v("删除负责人" + _vm._s(index + 1))])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin-top": "0.4rem"
    },
    attrs: {
      "native-type": "button",
      "size": "normal",
      "round": "",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.adminAdd()
      }
    }
  }, [_vm._v("新增负责人")])], 1), _vm._v(" "), _vm._l((_vm.formData.service_list), function(member, index) {
    return _c('div', {
      key: index
    }, [_c('van-divider', [_vm._v("赛事咨询人" + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
      attrs: {
        "clearable": "",
        "input-align": "right",
        "error-message-align": "right",
        "label": "姓名",
        "placeholder": "请输入姓名",
        "rules": [{
          required: true,
          message: '请输入姓名'
        }]
      },
      model: {
        value: (member.name),
        callback: function($$v) {
          _vm.$set(member, "name", $$v)
        },
        expression: "member.name"
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "clearable": "",
        "rules": [{
          validator: _vm.validator.phone,
          message: '请输入正确的手机号'
        }],
        "error-message-align": "right",
        "input-align": "right",
        "label": "手机",
        "placeholder": "请输入手机号"
      },
      model: {
        value: (member.phone),
        callback: function($$v) {
          _vm.$set(member, "phone", $$v)
        },
        expression: "member.phone"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.2rem"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('van-button', {
      staticStyle: {
        "width": "3rem"
      },
      attrs: {
        "native-type": "button",
        "size": "normal",
        "round": "",
        "icon": "close"
      },
      on: {
        "click": function($event) {
          return _vm.serviceRemove(member, index)
        }
      }
    }, [_vm._v("删除咨询人" + _vm._s(index + 1))])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin-top": "0.4rem"
    },
    attrs: {
      "native-type": "button",
      "size": "normal",
      "round": "",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.serviceAdd()
      }
    }
  }, [_vm._v("新增咨询人")])], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交申请")])], 1)], 2), _vm._v(" "), _c('van-calendar', {
    attrs: {
      "type": "range",
      "min-date": _vm.minDate,
      "max-date": _vm.maxDate
    },
    on: {
      "confirm": _vm.onDateConfirm
    },
    model: {
      value: (_vm.dateShow),
      callback: function($$v) {
        _vm.dateShow = $$v
      },
      expression: "dateShow"
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3487779b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/apps/sai/SaiquApplyFormStep1.vue
// module id = 2315
// module chunks = 0